import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { ContentContainer } from '../../components/ContentContainer';
import { RecordDataIndicators } from '../../components/RecordDataIndicators';
import { LocationList } from '../../components/LocationList/LocationList';
import { LocationListDataProvider } from '../../data/DataProviders/LocationListDataProvider';
import { DataProviderCache } from '../../data/DataProviders/DataProviderCache';
import { getUserId, useAuthState } from '../../components/AuthContextProvider';
import { AppRoutes } from '../../routes';
import { SiteManagement } from '../site-management/SiteManagement';
import { AddSiteContainer } from '../site-management/AddSiteContainer';

export const ManageLocation: React.FC = () => {
    const { t } = useLanguageLocale();
    const authState = useAuthState();
    const loggedInUserId = getUserId(authState) || '';
    const selectedOrganization = useSelectedOrganizationData();

    if (!isRecordFound(selectedOrganization)) {
        return (
            <ContentContainer>
                <RecordDataIndicators
                    recordData={selectedOrganization}
                    errorMessage={t('DASHBOARD.ERROR_LOADING_ORGANIZATION')}
                    notFoundIcon="Business"
                    notFoundMessage={t('DASHBOARD.ORGANIZATION_NOT_FOUND')}
                />
            </ContentContainer>
        );
    }
    return (
        <>
            <RecordDataIndicators
                recordData={selectedOrganization}
                errorMessage={'No location data'}
                notFoundIcon="Person"
                notFoundMessage={'No location data'}
            />
            <DataProviderCache for={'location-list'}>
                <LocationListDataProvider
                    organizationId={selectedOrganization.value.id}
                    userId={loggedInUserId}
                    operation="edit"
                >
                    <Switch>
                        <Route exact path={AppRoutes.ManageLocation}>
                            <LocationList />
                        </Route>
                        <Route exact path={AppRoutes.AddSite}>
                            <AddSiteContainer />
                        </Route>
                        <Route
                            path={[
                                AppRoutes.SiteProfile,
                                AppRoutes.AddDevice,
                                AppRoutes.EditConnectedDevice,
                                AppRoutes.AcquireSubscription,
                                AppRoutes.DeviceProfile,
                                AppRoutes.PxDeviceProfile,
                                AppRoutes.MeshDeviceProfile,
                                AppRoutes.StarfishDeviceProfile,
                                AppRoutes.ChildDeviceProfile,
                                AppRoutes.PxChildDeviceProfile,
                                AppRoutes.StarfishChildDeviceProfile,
                                AppRoutes.EditSite,
                                AppRoutes.EditDeviceProfile,
                                AppRoutes.EditStarfishConnectedDevice,
                            ]}
                        >
                            <SiteManagement />
                        </Route>
                    </Switch>
                </LocationListDataProvider>
            </DataProviderCache>
        </>
    );
};
